// extracted by mini-css-extract-plugin
module.exports = {"container":"mainContent_container__2Lko5","mainText":"mainContent_mainText__1r955"};